import {HTTP} from '@/http-common';

const state = {
  status: true,
  message: ''
};

const mutations = {
  SET_MAINTENANCE_STATUS(state, status) {
    state.status = status;
  },
  SET_MAINTENANCE_MESSAGE(state, message) {
    state.message = message;
  }
};

const getters = {
  getMaintenanceStatus: state => state.status,
  getMaintenanceMessage: state => state.message.replace(/(?:\r\n|\r|\n)/g, '<br />')
};

const actions = {
  checkMaintenanceStatus: ({commit}) => {
    HTTP.get(`status/maintenance-mode`)
      .then(response => {
        if (response.data.status === 'success') {
          commit('SET_MAINTENANCE_STATUS', response.data.data.maintenance_mode === "on");
          commit('SET_MAINTENANCE_MESSAGE', response.data.data.maintenance_message);
        }
        if (response.data.status === 'error') {
          commit('SET_MAINTENANCE_STATUS', true);
          commit('SET_MAINTENANCE_MESSAGE', 'An error occurred!');
        }
      }).catch(err => {
      console.log(err);
    });
  }
};

export default {
  state,
  mutations,
  getters,
  actions
};



// WEBPACK FOOTER //
// ./src/store/modules/maintenance.js